import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "template-table-head-row" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("th", { class: "table-checkbox" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "uk-checkbox",
    type: "checkbox"
  })
], -1)
const _hoisted_3 = { class: "uk-width-1-4" }
const _hoisted_4 = { class: "uk-table-shrink" }
const _hoisted_5 = { class: "uk-table-shrink" }
const _hoisted_6 = { class: "uk-table-shrink" }
const _hoisted_7 = { class: "uk-width-1-6" }
const _hoisted_8 = { class: "uk-table-expand" }
const _hoisted_9 = { class: "uk-width-1-6" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("td", { class: "table-checkbox" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "uk-checkbox",
    type: "checkbox"
  })
], -1)
const _hoisted_11 = { class: "custom-code" }
const _hoisted_12 = { class: "template-tags uk-flex" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_the_tag = _resolveComponent("the-tag")!
  const _component_action_icons = _resolveComponent("action-icons")!
  const _component_base_table = _resolveComponent("base-table")!

  return (_openBlock(), _createBlock(_component_base_table, { id: "templates-table" }, {
    tableHead: _withCtx(() => [
      _createElementVNode("tr", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("th", _hoisted_3, _toDisplayString(_ctx.$t('index_templates.templates_table.slug')), 1),
        _createElementVNode("th", _hoisted_4, _toDisplayString(_ctx.$t('index_templates.templates_table.language')), 1),
        _createElementVNode("th", _hoisted_5, _toDisplayString(_ctx.$t('index_templates.templates_table.tonality')), 1),
        _createElementVNode("th", _hoisted_6, _toDisplayString(_ctx.$t('index_templates.templates_table.group')), 1),
        _createElementVNode("th", _hoisted_7, _toDisplayString(_ctx.$t('index_templates.templates_table.tags')), 1),
        _createElementVNode("th", _hoisted_8, _toDisplayString(_ctx.$t('index_templates.templates_table.actions')), 1),
        _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t('index_templates.templates_table.updated_at')), 1)
      ])
    ]),
    tableBody: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.templatesGroupedBySlug, (templates, slug, index) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: templates[0].id,
          class: "template-table-row"
        }, [
          _hoisted_10,
          _createElementVNode("td", null, [
            _createVNode(_component_router_link, {
              to: `/templates/${slug}`,
              class: "custom-link"
            }, {
              default: _withCtx(() => [
                _createElementVNode("code", _hoisted_11, _toDisplayString(slug), 1)
              ]),
              _: 2
            }, 1032, ["to"])
          ]),
          _createElementVNode("td", null, _toDisplayString(_ctx.getTemplatesLanguages(templates).join(', ')), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.getTemplatesTonalities(templates).join(', ')), 1),
          _createElementVNode("td", null, _toDisplayString(_ctx.getTemplatesGroups(templates).join(', ')), 1),
          _createElementVNode("td", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getTemplatesTags(templates), (tag) => {
              return (_openBlock(), _createBlock(_component_the_tag, {
                key: tag,
                text: tag!,
                class: "uk-margin-small-bottom"
              }, null, 8, ["text"]))
            }), 128))
          ]),
          _createElementVNode("td", null, [
            _createVNode(_component_action_icons, {
              slug: String(slug),
              kind: _ctx.kind,
              "external-index": index,
              onExport: ($event: any) => (_ctx.exportTemplate(slug)),
              onCopy: ($event: any) => (_ctx.copyTemplateVariantsHandler(String(slug))),
              onDelete: ($event: any) => (_ctx.destroyTemplateVariantsHandler(String(slug)))
            }, null, 8, ["slug", "kind", "external-index", "onExport", "onCopy", "onDelete"])
          ]),
          _createElementVNode("td", null, _toDisplayString(_ctx.getLatestUpdatedAtDate(templates)), 1)
        ]))
      }), 128))
    ]),
    _: 1
  }))
}